import { render } from "./GraphCuration.vue?vue&type=template&id=397809ee&scoped=true"
import script from "./GraphCuration.vue?vue&type=script&lang=js"
export * from "./GraphCuration.vue?vue&type=script&lang=js"

import "./GraphCuration.vue?vue&type=style&index=0&id=397809ee&scoped=true&lang=css"
import "./GraphCuration.vue?vue&type=style&index=1&id=397809ee&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397809ee"]])

export default __exports__